// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pres-filter-card {
  background: var(--white-principale);
  border: 1px solid var(--color-border);
  border-radius: var(--bs-border-radius-lg);
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
}

.pres-filter-label-section {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--color-ink-faint);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pres-filter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 12px;
  align-items: end;
}

.pres-filter-field label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-ink-soft);
  margin-bottom: 5px;
}

.pres-filter-field input,
.pres-filter-field select {
  width: 100%;
  height: 40px;
  border: 1px solid var(--color-border);
  border-radius: var(--bs-border-radius);
  padding: 0 12px;
  font-size: 14px;
  color: var(--color-ink);
  background: var(--white-principale);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.pres-filter-field input:focus,
.pres-filter-field select:focus {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.12);
}

.pres-btn-group {
  display: flex;
  gap: 8px;
  padding-top: 2px;
}

.pres-btn-primary {
  background: var(--bs-primary);
  color: var(--white-principale);
  border: none;
  border-radius: var(--bs-border-radius);
  padding: 0 18px;
  height: 40px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  transition: background 0.15s;
}

.pres-btn-primary:hover {
  background: var(--bs-link-hover-color);
}

.pres-btn-reset {
  background: transparent;
  color: var(--color-ink-soft);
  border: 1px solid var(--color-border);
  border-radius: var(--bs-border-radius);
  padding: 0 14px;
  height: 40px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: background 0.15s, border-color 0.15s;
}

.pres-btn-reset:hover {
  background: var(--color-surface-alt);
  border-color: #ccc;
}

/* Banner entreprise */
.pres-company-banner {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(var(--bs-primary-rgb), 0.06);
  border: 1px solid rgba(var(--bs-primary-rgb), 0.18);
  border-radius: var(--bs-border-radius);
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.pres-company-banner .cname {
  font-size: 13px;
  font-weight: 600;
  color: var(--bs-link-hover-color);
  display: flex;
  align-items: center;
  gap: 5px;
}

.pres-company-banner .vsep {
  width: 1px;
  height: 16px;
  background: rgba(var(--bs-primary-rgb), 0.25);
}

.pres-company-banner .hbadge {
  font-size: 13px;
  color: var(--bs-primary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.pres-company-banner .hbadge strong {
  font-weight: 600;
}

/* Table */
.pres-table-card {
  background: var(--white-principale);
  border: 1px solid var(--color-border);
  border-radius: var(--bs-border-radius-lg);
  overflow: hidden;
}

.pres-table-head {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--color-border-soft);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.pres-table-head h2 {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-ink);
  margin: 0;
}

.pres-count-badge {
  font-size: 12px;
  color: var(--color-ink-faint);
  background: var(--color-surface-alt);
  border-radius: 999px;
  padding: 3px 12px;
  white-space: nowrap;
}

.pres-table-card table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.pres-table-card thead th {
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-ink-faint);
  border-bottom: 1px solid var(--color-border-soft);
  background: var(--color-surface);
  text-align: left;
  white-space: nowrap;
}

.pres-table-card tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f7f7f7;
  color: var(--color-ink);
  vertical-align: middle;
}

.pres-table-card tbody tr:hover td {
  background: var(--color-surface);
}

.pres-empty td {
  text-align: center;
  color: var(--color-ink-mute);
  padding: 3rem 0 !important;
  font-size: 13px;
}

/* User */
.pres-user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pres-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(var(--bs-primary-rgb), 0.12);
  color: var(--bs-primary);
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  flex-shrink: 0;
}

.pres-uname {
  font-weight: 600;
  font-size: 13px;
  color: var(--color-ink);
}

.pres-uemail {
  font-size: 11px;
  color: var(--color-ink-mute);
}

/* Date / time */
.pres-date-chip {
  font-size: 12px;
  background: var(--color-surface-alt);
  border: 1px solid var(--color-border-soft);
  border-radius: 6px;
  padding: 3px 9px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--color-ink-soft);
  white-space: nowrap;
}

.pres-time {
  font-variant-numeric: tabular-nums;
  font-size: 13px;
  white-space: nowrap;
}

/* Progress */
.pres-pct-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pres-pct-bg {
  flex: 1 1;
  height: 5px;
  background: var(--color-border-soft);
  border-radius: 99px;
  overflow: hidden;
  max-width: 70px;
}

.pres-pct-fill {
  height: 100%;
  border-radius: 99px;
  background: var(--brand-live);
}

.pres-pct-label {
  font-size: 12px;
  color: var(--color-ink-faint);
  min-width: 40px;
  text-align: right;
}

/* Pagination */
.pres-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  border-top: 1px solid var(--color-border-soft);
  gap: 10px;
  flex-wrap: wrap;
}

.pres-pagination .pinfo {
  font-size: 12px;
  color: var(--color-ink-mute);
}

.pres-page-btns {
  display: flex;
  align-items: center;
  gap: 5px;
}

.pres-page-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-soft);
  border-radius: 7px;
  background: var(--white-principale);
  cursor: pointer;
  font-size: 12px;
  color: var(--color-ink-soft);
  transition: background 0.15s;
}

.pres-page-btn:hover:not(:disabled) {
  background: var(--color-surface-alt);
}

.pres-page-btn.active {
  background: var(--color-ink);
  color: var(--white-principale);
  border-color: var(--color-ink);
  font-weight: 600;
}

.pres-page-btn:disabled {
  opacity: 0.3;
  cursor: default;
}

/* ----------- Responsive ----------- */

@media (max-width: 768px) {
  .pres-filter-card {
    padding: 1rem;
  }

  .pres-filter-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .pres-btn-group {
    padding-top: 4px;
  }

  .pres-btn-primary,
  .pres-btn-reset {
    flex: 1 1;
  }

  .pres-company-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .pres-company-banner .vsep {
    display: none;
  }

  .pres-table-head {
    padding: 0.85rem 1rem;
  }

  .pres-pagination {
    padding: 0.75rem 1rem;
    justify-content: center;
    text-align: center;
  }

  .pres-pagination .pinfo {
    width: 100%;
    order: 2;
  }

  .pres-page-btns {
    order: 1;
  }
}

@media (max-width: 480px) {

  .pres-filter-field input,
  .pres-filter-field select {
    height: 42px;
    font-size: 15px;
    /* évite le zoom auto iOS Safari sur focus d'un input < 16px */
  }

  .pres-user-cell {
    gap: 8px;
  }

  .pres-avatar {
    width: 28px;
    height: 28px;
    font-size: 10px;
  }

  .pres-uemail {
    display: none;
    /* trop serré sur mobile, le nom seul suffit dans la cellule */
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/PresenceList.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,yCAAyC;EACzC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;EACb,gDAAgD;AAClD;;AAEA;;EAEE,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,mDAAmD;EACnD,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,mCAAmC;EACnC,qCAAqC;EACrC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,iDAAiD;EACjD,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,8CAA8C;EAC9C,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,uCAAuC;;AAEvC;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;;EAEE;;IAEE,YAAY;IACZ,eAAe;IACf,8DAA8D;EAChE;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8DAA8D;EAChE;AACF","sourcesContent":[".pres-filter-card {\n  background: var(--white-principale);\n  border: 1px solid var(--color-border);\n  border-radius: var(--bs-border-radius-lg);\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.pres-filter-label-section {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--color-ink-faint);\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pres-filter-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr auto;\n  gap: 12px;\n  align-items: end;\n}\n\n.pres-filter-field label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-ink-soft);\n  margin-bottom: 5px;\n}\n\n.pres-filter-field input,\n.pres-filter-field select {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--bs-border-radius);\n  padding: 0 12px;\n  font-size: 14px;\n  color: var(--color-ink);\n  background: var(--white-principale);\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.pres-filter-field input:focus,\n.pres-filter-field select:focus {\n  border-color: var(--bs-primary);\n  box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.12);\n}\n\n.pres-btn-group {\n  display: flex;\n  gap: 8px;\n  padding-top: 2px;\n}\n\n.pres-btn-primary {\n  background: var(--bs-primary);\n  color: var(--white-principale);\n  border: none;\n  border-radius: var(--bs-border-radius);\n  padding: 0 18px;\n  height: 40px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n\n.pres-btn-primary:hover {\n  background: var(--bs-link-hover-color);\n}\n\n.pres-btn-reset {\n  background: transparent;\n  color: var(--color-ink-soft);\n  border: 1px solid var(--color-border);\n  border-radius: var(--bs-border-radius);\n  padding: 0 14px;\n  height: 40px;\n  font-size: 13px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.pres-btn-reset:hover {\n  background: var(--color-surface-alt);\n  border-color: #ccc;\n}\n\n/* Banner entreprise */\n.pres-company-banner {\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  background: rgba(var(--bs-primary-rgb), 0.06);\n  border: 1px solid rgba(var(--bs-primary-rgb), 0.18);\n  border-radius: var(--bs-border-radius);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.pres-company-banner .cname {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--bs-link-hover-color);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.pres-company-banner .vsep {\n  width: 1px;\n  height: 16px;\n  background: rgba(var(--bs-primary-rgb), 0.25);\n}\n\n.pres-company-banner .hbadge {\n  font-size: 13px;\n  color: var(--bs-primary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pres-company-banner .hbadge strong {\n  font-weight: 600;\n}\n\n/* Table */\n.pres-table-card {\n  background: var(--white-principale);\n  border: 1px solid var(--color-border);\n  border-radius: var(--bs-border-radius-lg);\n  overflow: hidden;\n}\n\n.pres-table-head {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--color-border-soft);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pres-table-head h2 {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-ink);\n  margin: 0;\n}\n\n.pres-count-badge {\n  font-size: 12px;\n  color: var(--color-ink-faint);\n  background: var(--color-surface-alt);\n  border-radius: 999px;\n  padding: 3px 12px;\n  white-space: nowrap;\n}\n\n.pres-table-card table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.pres-table-card thead th {\n  padding: 10px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-ink-faint);\n  border-bottom: 1px solid var(--color-border-soft);\n  background: var(--color-surface);\n  text-align: left;\n  white-space: nowrap;\n}\n\n.pres-table-card tbody td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f7f7f7;\n  color: var(--color-ink);\n  vertical-align: middle;\n}\n\n.pres-table-card tbody tr:hover td {\n  background: var(--color-surface);\n}\n\n.pres-empty td {\n  text-align: center;\n  color: var(--color-ink-mute);\n  padding: 3rem 0 !important;\n  font-size: 13px;\n}\n\n/* User */\n.pres-user-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pres-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: rgba(var(--bs-primary-rgb), 0.12);\n  color: var(--bs-primary);\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.pres-uname {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--color-ink);\n}\n\n.pres-uemail {\n  font-size: 11px;\n  color: var(--color-ink-mute);\n}\n\n/* Date / time */\n.pres-date-chip {\n  font-size: 12px;\n  background: var(--color-surface-alt);\n  border: 1px solid var(--color-border-soft);\n  border-radius: 6px;\n  padding: 3px 9px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--color-ink-soft);\n  white-space: nowrap;\n}\n\n.pres-time {\n  font-variant-numeric: tabular-nums;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n/* Progress */\n.pres-pct-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pres-pct-bg {\n  flex: 1;\n  height: 5px;\n  background: var(--color-border-soft);\n  border-radius: 99px;\n  overflow: hidden;\n  max-width: 70px;\n}\n\n.pres-pct-fill {\n  height: 100%;\n  border-radius: 99px;\n  background: var(--brand-live);\n}\n\n.pres-pct-label {\n  font-size: 12px;\n  color: var(--color-ink-faint);\n  min-width: 40px;\n  text-align: right;\n}\n\n/* Pagination */\n.pres-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.5rem;\n  border-top: 1px solid var(--color-border-soft);\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pres-pagination .pinfo {\n  font-size: 12px;\n  color: var(--color-ink-mute);\n}\n\n.pres-page-btns {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.pres-page-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-soft);\n  border-radius: 7px;\n  background: var(--white-principale);\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--color-ink-soft);\n  transition: background 0.15s;\n}\n\n.pres-page-btn:hover:not(:disabled) {\n  background: var(--color-surface-alt);\n}\n\n.pres-page-btn.active {\n  background: var(--color-ink);\n  color: var(--white-principale);\n  border-color: var(--color-ink);\n  font-weight: 600;\n}\n\n.pres-page-btn:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n/* ----------- Responsive ----------- */\n\n@media (max-width: 768px) {\n  .pres-filter-card {\n    padding: 1rem;\n  }\n\n  .pres-filter-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .pres-btn-group {\n    padding-top: 4px;\n  }\n\n  .pres-btn-primary,\n  .pres-btn-reset {\n    flex: 1;\n  }\n\n  .pres-company-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .pres-company-banner .vsep {\n    display: none;\n  }\n\n  .pres-table-head {\n    padding: 0.85rem 1rem;\n  }\n\n  .pres-pagination {\n    padding: 0.75rem 1rem;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .pres-pagination .pinfo {\n    width: 100%;\n    order: 2;\n  }\n\n  .pres-page-btns {\n    order: 1;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .pres-filter-field input,\n  .pres-filter-field select {\n    height: 42px;\n    font-size: 15px;\n    /* évite le zoom auto iOS Safari sur focus d'un input < 16px */\n  }\n\n  .pres-user-cell {\n    gap: 8px;\n  }\n\n  .pres-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 10px;\n  }\n\n  .pres-uemail {\n    display: none;\n    /* trop serré sur mobile, le nom seul suffit dans la cellule */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
